import { apiClient as api } from './apiClient';

export interface Operation {
  id: number;
  name: string;
  description: string;
  createdDate: string;
  isActive: boolean;
}

export const getOperations = async (): Promise<Operation[]> => {
  try {
    const response = await api.get('/operations');
    return response.data;
  } catch (error) {
    console.error('Error fetching operations:', error);
    throw error;
  }
};

export const getOperationById = async (id: number): Promise<Operation> => {
  try {
    const response = await api.get(`/operations/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching operation ${id}:`, error);
    throw error;
  }
};

export const createOperation = async (operation: Omit<Operation, 'id' | 'createdDate'>): Promise<Operation> => {
  try {
    const response = await api.post('/operations', operation);
    return response.data;
  } catch (error) {
    console.error('Error creating operation:', error);
    throw error;
  }
};